<template>
  <section class="l-content-area">
    <div class="l-content l-content--reservation">
      <div class="l-wrap__outer">
        <div class="l-wrap__inner">
          <section class="c-title__bloc c-title__bloc--reservation">
            <h1>新規来店予約申し込み登録</h1>
            <div class="c-btn c-btn--title-back"><a href="" @click="prevToStep">戻る</a></div>
          </section>
          <section class="p-bloc p-bloc__reservation">
            <h2 class="p-reservation__step">STEP 3</h2>
            <div class="p-reservation__bloc">
              <p>ご希望の項目を選択してください。</p>
              <div v-if="!isConclusion" class="p-reservation__designcut">
                <div
                  v-for="(design, index) in listDesignCut"
                  :key="index"
                  class="c-designcut__bloc"
                >
                  <a href="" @click.prevent="nextToStep(design.id)">
                    <h2>{{ design.name }}</h2>
                    <h3 v-if="design.price !== ''">初回お試し価格：{{ design.price }}円（税込）</h3>
                    <p>{{ design.description }}</p>
                  </a>
                </div>
              </div>
              <div v-else class="p-reservation__concierge">
                <p v-if="error" class="text-center text-danger">
                  {{ error }}
                </p>
                <div
                  v-for="(conclusion, index) in listConclusion"
                  :key="index"
                  class="c-concierge__bloc"
                >
                  <dl>
                    <dt>
                      <input
                        :id="`consult-${index}`"
                        type="checkbox"
                        :value="conclusion.id"
                        :checked="treatmentContent.indexOf(conclusion.id) !== -1"
                        @change="getValueSelected($event, conclusion.id)"
                        @input="conclusion.id = $event.target.value"
                      />
                      <label :for="`consult-${index}`">
                        <span>{{ conclusion.name }}</span>
                      </label>
                      <div class="c-tag c-tag--consult">
                        <span>ご相談</span>
                      </div>
                    </dt>
                    <dd>
                      {{ conclusion.description }}
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
            <button-registration
              :prev-text="'戻る'"
              :next-text="'次へ'"
              :is-next-button="isConclusion"
              :prev-text-color="'#787878'"
              :handle-prev-button="prevToStep"
              :handle-next-button="nextToStep"
            ></button-registration>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import ButtonRegistration from '../common/ButtonRegistration'
import { listDesignCut } from '../../constant/listDesignCut'
import {
  getTreatmentByCategory,
  requestRegisterReservationCancel,
} from '../../actions/requestReservation'
import { rulesValidateArrayRequired } from '../../helpers/schemaValidate'
import { SERVICE_INVALID } from '../../constant/text'
import { scrollToTop } from '../../helpers'
import { getDateTimeFormatString } from '../../helpers/formatDate'

export default {
  name: 'ReservationSpecial',
  components: { ButtonRegistration },
  props: {
    studio: {
      type: String,
      default: '1',
    },
    isConclusion: {
      type: Boolean,
      default: false,
    },
    currentStep: {
      type: String,
      default: '4',
    },
    treatmentContent: {
      type: Array,
      default: () => {
        return []
      },
    },
    isForceValidate: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      listDesignCut,
      listConclusion: [],
      error: '',
    }
  },
  watch: {
    studio(newVal) {
      if (newVal) {
        this.getTreatment()
      }
    },
    isForceValidate(newVal) {
      if (newVal && this.currentStep === '4' && this.isConclusion) {
        this.nextToStep()
      }
    },
    treatmentContent(newVal) {
      if (this.isConclusion) {
        const values = {
          treatmentContent: newVal,
        }
        rulesValidateArrayRequired('treatmentContent', SERVICE_INVALID)
          .validateAt('treatmentContent', values)
          .then(() => {
            this.error = ''
            this.$emit('onValidateSwipe', false)
          })
          .catch(error => {
            this.error = error.message
            this.$emit('onValidateSwipe', false)
          })
      }
    },
  },
  created() {
    this.getTreatment()
  },
  methods: {
    nextToStep(value) {
      if (this.isConclusion) {
        const values = {
          treatmentContent: this.treatmentContent,
        }
        rulesValidateArrayRequired('treatmentContent', SERVICE_INVALID)
          .validateAt('treatmentContent', values)
          .then(() => {
            this.$emit('nextToStep', this.treatmentContent)
          })
          .catch(error => {
            scrollToTop()
            this.error = error.message
          })
      } else {
        const dateTime = null
        const isDesignCut = true
        const service = [value]
        this.$emit('startLoading')
        requestRegisterReservationCancel(this.userId, this.studio, dateTime, isDesignCut, service)
          .then(res => {
            const {
              data: { success },
            } = res
            if (success && success === 1) {
              this.$emit('onHandleChange', 'reservationId', res.data.data.id.toString())
            }
            this.$emit('endLoading')
          })
          .catch(err => {
            this.$emit('endLoading')
            if (err.response.data.error !== undefined) {
              this.$toast.error(err.response.data.error.status)
            }
            return err
          })
        this.$emit('nextToStep', [value])
      }
    },
    prevToStep() {
      this.error = ''
      this.$emit('prevToStep', '3')
    },
    getValueSelected(e, value) {
      const {
        target: { checked },
      } = e
      const listTreatmentSelected = [...this.treatmentContent]
      if (checked) {
        listTreatmentSelected.push(value)
        this.$emit('nextToStep', listTreatmentSelected, false)
      } else {
        const newListTreatment = listTreatmentSelected.filter(
          treatment => treatment.toString() !== value.toString()
        )
        this.$emit('nextToStep', newListTreatment, false)
      }
    },
    getTreatment() {
      this.$emit('startLoading')
      getTreatmentByCategory('con', this.studio)
        .then(response => {
          this.$emit('endLoading')
          const {
            data: { success },
          } = response
          if (success === 1) {
            const {
              data: { data },
            } = response
            this.listConclusion = data
          }
        })
        .catch(error => {
          this.$emit('endLoading')
          console.log(error)
        })
    },
  },
}
</script>
<style scoped>
.v-application ul,
.v-application ol {
  padding-left: 0 !important;
}

.v-application a {
  color: #0a005a;
}

.text-danger {
  color: #ef5757;
  padding: 10px;
  background: #faebd7;
}
</style>
